import * as React from "react";
import {
  IPeerGroupTabsProps,
  IVisualizationState,
  IFilter,
  getPeerGroupData,
} from "../../lib/http";
import { Table } from "react-bootstrap";
import { round } from "lodash";

export class PeerGroupTable extends React.Component<
  IPeerGroupTabsProps,
  IVisualizationState
  > {
  state: IVisualizationState = {
    categories: [],
    data: [],
    series: [],
    filters: { assetLevel: -1 },
    title: "",
    loading: false,
    average: [],
  };

  componentDidMount() {
    this.setState({ data: this.props.data }, () =>
      this.loadSeries(this.props.filters)
    );
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.filters.assetLevel !== this.props.filters.assetLevel ||
      prevProps.data.length !== this.props.data.length
    ) {
      this.setState(
        { filters: this.props.filters, data: this.props.data },
        () => {
          this.loadSeries(this.props.filters);
        }
      );
    }
  }

  mapFilterIdToColumn(filterId) {
    if (filterId === 0) return '';
    if (filterId === 2) return 'fiveHundred';
    if (filterId === 3) return 'fifty';
    if (filterId === 4) return 'five';
    if (filterId === 5) return 'twenty';
    if (filterId === 6) return 'two';
    if (filterId === 7) return 'oneHundred';
    if (filterId === 8) return 'ten';
    if (filterId === 9) return 'one';
  }

  loadSeries(filters: IFilter) {
    const performanceBody = {
      action: "getPeerGroupPerformanceTable",
      request: { assetLevel: this.props.filters.assetLevel },
    }
    const column = this.mapFilterIdToColumn(filters.assetLevel)
    getPeerGroupData(performanceBody).then((response) => {

      const series = []
      const givRow = response.find(dataPoint => dataPoint.label === 'giv');
      const peerGroupRow = response.find(dataPoint => dataPoint.label === column);

      if (givRow) series.push(givRow)
      if (peerGroupRow) series.push(peerGroupRow)

      this.setState({ series })
    })
  }

  render() {
    const { series } = this.state
    const { assetName } = this.props.filters
    return (
      <Table>
        <thead>
          <tr>
            <th>Index</th>
            <th>YTD</th>
            <th>1 Year</th>
            <th>3 Year</th>
            <th>5 Year</th>
          </tr>
        </thead>
        <tbody>
          {series && series.length > 0 && series.map(currentSeries => {
            return (
              <tr key={currentSeries['label']}>
                <td>{currentSeries['label'] === 'giv' ? 'GIV Index' : assetName + ' Index'}</td>
                <td>{round(currentSeries['yearToDate'], 1).toFixed(1)}%</td>
                <td>{round(currentSeries['oneYear'], 1).toFixed(1)}%</td>
                <td>{round(currentSeries['threeYear'], 1).toFixed(1)}%</td>
                <td>{round(currentSeries['fiveYear'], 1).toFixed(1)}%</td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/Performance/PeerGroupTable/index.tsx